const en = {
  brand: "MC Illusions Prints",
  nav: { order: "Order", types: "DTF vs UV DTF", pricing: "Pricing", work: "Our work", track: "Track order", cart: "Cart", admin: "Admin" },
  hero: {
    eyebrow: "Custom DTF & UV DTF transfers",
    title1: "Your logo.",
    title2: "On everything",
    title3: "you sell.",
    sub: "Upload your PNG, pick DTF or UV DTF, choose the size and see your price instantly. Printed in Quebec and shipped straight to your door in plain packaging.",
    cta: "Start your order",
    cta2: "See pricing",
    b1: "No minimums",
    b2: "Instant CAD pricing",
    b3: "Ships across Canada",
  },
  types: {
    title: "Two ways to put your brand on merch",
    sub: "Not sure which one you need? Fabric gets DTF. Everything hard and smooth gets UV DTF.",
    dtf: "DTF transfers",
    dtf_for: "Garments & fabric",
    dtf_desc: "Heat-press onto t-shirts, hoodies, hats, tote bags and uniforms. Soft, stretchy and wash-durable on cotton, polyester and blends.",
    dtf_l: ["T-shirts & hoodies", "Hats & tote bags", "Work uniforms", "Up to 22\" × 96\""],
    uv: "UV DTF decals",
    uv_for: "Hard surfaces",
    uv_desc: "Peel-and-stick onto cups, tumblers, glass, metal, laptops and packaging. No heat press needed. Waterproof and scratch-resistant.",
    uv_l: ["Cups & tumblers", "Glass & metal", "Laptops & phone cases", "Up to 20\" × 60\""],
  },
  work: {
    title: "Fresh off the press",
    sub: "Real prints we've made for small businesses.",
    empty: "Our latest work lives on Instagram.",
    follow: "Follow @mcillusionsprints",
  },
  how: {
    title: "How it works",
    s1: "Upload your logo",
    s1d: "A transparent PNG at 300 dpi gives the sharpest print.",
    s2: "Pick type & size",
    s2d: "DTF or UV DTF, any size in inches, any quantity.",
    s3: "Pay securely",
    s3d: "See the exact price before paying by card.",
    s4: "Get your prints",
    s4d: "Shipped to you in plain packaging, ready to apply.",
  },
  pricing: {
    title: "Simple, honest pricing",
    sub: "All prices in CAD. The more DTF you order, the cheaper every square inch gets.",
    dtf_head: "DTF · total DTF area in your order",
    rate_head: "Price / sq in",
    upto: "Up to {n} sq in",
    over: "Over {n} sq in",
    uv_head: "UV DTF",
    uv_rate: "{rate} / sq in",
    uv_note: "One flat rate, any quantity.",
    setup: "Setup fee per design & size",
    extras: "Optional extras",
    rush: "Rush same-day",
    rush_v: "× {n} print cost",
    cut: "Cut each piece",
    cut_v: "{fee} / piece",
    check: "File check",
    check_v: "{fee} / file",
    ship: "Shipping",
    ship_v: "{flat} flat · free over {free}",
    example: "Example: 50 logos at 4\" × 4\" in DTF = 800 sq in → {rate} / sq in.",
  },
  cta: { title: "Ready to see your logo in print?", sub: "Get an instant price in under a minute.", btn: "Start your order" },
  builder: {
    title: "Build your order",
    sub: "Upload a logo, set the size and quantity, and watch the price update live.",
    s1: "Print type",
    s2: "Your logo",
    rules: ["PNG only", "300 dpi", "Transparent background", "Sized at actual print size"],
    drop: "Drop your PNG here or click to browse",
    drop_sub: "PNG with transparent background · max 50 MB",
    uploading: "Uploading & checking your file…",
    replace: "Replace file",
    px: "{w} × {h} px",
    dpi: "{dpi} dpi",
    dpi_unknown: "dpi not set",
    sharp: "Prints sharp up to {w}\" × {h}\" at 300 dpi",
    warn_soft: "Your file is smaller than this print size at 300 dpi. It may print soft or pixelated.",
    s3: "Size (inches)",
    width: "Width",
    height: "Height",
    presets: "Quick sizes (longest side)",
    lock: "Keep logo proportions",
    limits_dtf: "DTF: 0.5\" min · max 22\" × 96\"",
    limits_uvdtf: "UV DTF: 0.5\" min · max 20\" × 60\"",
    s4: "Quantity",
    pieces: "pieces",
    notes: "Notes (optional)",
    notes_ph: "Anything we should know? e.g. colours, placement…",
    s5: "Extras",
    rush: "Rush same-day",
    rush_d: "Doubles the print cost. Order before 12 pm ET for same-day production.",
    cut: "Cut each piece",
    cut_d: "{fee} per piece, ready to press or peel.",
    check: "File check",
    check_d: "{fee} per file. A pro reviews your file before printing.",
    summary: "Your price",
    area: "Area per piece",
    total_area: "Total area",
    rate: "Rate",
    print: "Print",
    extras: "Extras",
    setup: "Setup (per design)",
    line_total: "Line total",
    per_piece: "≈ {p} per piece",
    add: "Add to cart",
    added: "Added to cart",
    need_file: "Upload your logo to continue",
    tier_note: "DTF rate based on {area} sq in total in your cart.",
    rush_cutoff: "After 12 pm ET, rush orders start production the next business day.",
  },
  cart: {
    title: "Your cart",
    empty: "Your cart is empty.",
    start: "Start your order",
    more: "Add another design",
    checkout: "Checkout",
    subtotal: "Subtotal",
    shipping: "Shipping",
    free: "Free",
    total: "Total",
    tax_note: "Sales tax (GST/QST or HST) is added at payment.",
    free_left: "Add {amt} more for free shipping",
    free_got: "You've unlocked free shipping",
    remove: "Remove",
    qty: "Qty",
    each: "each",
  },
  checkout: {
    title: "Checkout",
    contact: "Contact",
    name: "Full name",
    business: "Business name",
    email: "Email",
    phone: "Phone",
    ship_to: "Ship to",
    line1: "Street address",
    line2: "Apt, suite, unit (optional)",
    city: "City",
    province: "Province",
    postal: "Postal code",
    country: "Canada",
    pay: "Pay securely",
    pay_card: "Pay by card",
    pay_paypal: "Pay with PayPal",
    or: "or",
    paypal_tax: "With PayPal, GST/QST/HST for your province is added on PayPal's page.",
    redirecting: "Redirecting to secure payment…",
    note: "You'll be redirected to Stripe to pay by card. Shipped in plain packaging.",
    summary: "Order summary",
    required: "Please fill in all required fields.",
    postal_bad: "Please enter a valid Canadian postal code.",
    email_bad: "Please enter a valid email.",
  },
  success: {
    checking: "Confirming your payment…",
    title: "Thank you! Your order is confirmed.",
    order_no: "Order number",
    keep: "Keep this number to track your order. Use it with your email on the tracking page.",
    track: "Track my order",
    home: "Back to home",
    pending: "Still confirming your payment. This page will update automatically.",
    failed: "We couldn't confirm your payment. If you were charged, contact us with your email.",
  },
  cancel: { title: "Payment cancelled", sub: "No charge was made. Your cart is still saved.", back: "Back to cart" },
  track: {
    title: "Track your order",
    sub: "Enter your order number and the email you used at checkout.",
    order_no: "Order number",
    email: "Email",
    submit: "Find my order",
    placed: "Placed on {d}",
    tracking: "Tracking number",
    items: "Items",
    timeline: "Progress",
  },
  status: {
    awaiting_payment: "Awaiting payment",
    paid: "Order received",
    sent_to_ton_atelier: "Queued for printing",
    in_production: "In production",
    shipped: "Shipped",
    delivered: "Delivered",
    cancelled: "Cancelled",
  },
  admin_status: {
    all: "All",
    awaiting_payment: "Awaiting payment",
    paid: "Paid",
    sent_to_ton_atelier: "Sent to Ton Atelier",
    in_production: "In production",
    shipped: "Shipped",
    delivered: "Delivered",
    cancelled: "Cancelled",
  },
  common: { dtf: "DTF", uvdtf: "UV DTF", rush: "Rush", cut: "Cut", check: "File check", loading: "Loading…", save: "Save", saved: "Saved" },
  footer: { tag: "Custom DTF & UV DTF transfers for small businesses.", made: "Printed in Quebec, Canada.", rights: "All rights reserved." },
  admin: {
    login_title: "Admin sign in",
    email: "Email",
    password: "Password",
    sign_in: "Sign in",
    logout: "Log out",
    orders: "Orders",
    settings: "Pricing & shipping",
    gallery: "Gallery",
    view_site: "View site",
    no_orders: "No orders here yet.",
    order: "Order",
    date: "Date",
    customer: "Customer",
    items: "Items",
    total: "Total",
    profit: "Profit",
    status: "Status",
    back: "All orders",
    contact: "Customer",
    ship_to: "Ship to (ghost shipping)",
    copy: "Copy address",
    copied: "Copied",
    lines: "Print lines",
    download: "Download PNG",
    breakdown: "Money breakdown",
    ta_cost: "Ton Atelier cost",
    your_profit: "Your profit",
    subtotal: "Subtotal",
    shipping: "Shipping charged",
    tax: "Tax collected",
    paid: "Paid by customer",
    manage: "Manage order",
    tracking: "Tracking number",
    notes: "Internal notes",
    update: "Save changes",
    updated: "Order updated",
    history: "History",
    customer_notes: "Customer notes",
    lang: "Language",
    dtf_tiers: "DTF tiers (total DTF area in order)",
    min_area: "Over (sq in)",
    rate: "Ton Atelier rate / sq in",
    add_tier: "Add tier",
    uv_rate: "UV DTF Ton Atelier rate / sq in",
    markup: "Your markup (× Ton Atelier print cost, 2 = double)",
    profit_line: "Setup fee per design/size line (extra profit)",
    rush_mult: "Rush multiplier (print cost ×)",
    cut_fee: "Cut fee per piece",
    file_fee: "File check per file",
    ship_flat: "Flat shipping",
    free_over: "Free shipping over",
    save_settings: "Save pricing",
    settings_saved: "Pricing saved",
    pw_title: "Change password",
    pw_current: "Current password",
    pw_new: "New password (min 8 characters)",
    pw_save: "Update password",
    pw_saved: "Password updated",
    gallery_sub: "Upload photos or short videos of your work. They appear in the “Fresh off the press” section on the homepage.",
    gallery_add: "Upload photo or video",
    gallery_caption: "Caption (optional)",
    gallery_empty: "No photos yet. Upload your first one!",
    gallery_uploaded: "Uploaded to gallery",
    delete: "Remove",
    delete_confirm: "Remove this item from the gallery?",
    email_confirmation: "Confirmation email",
    email_shipped: "Shipped email",
  },
  errors: {
    generic: "Something went wrong. Please try again.",
    not_png: "Only PNG files are accepted.",
    no_transparency: "Your PNG needs a transparent background.",
    too_large: "File is too large (max 50 MB).",
    invalid_image: "We couldn't read this file. Please upload a valid PNG.",
    missing_upload: "One of your logos is missing. Please re-add it.",
    size_out_of_range_dtf: "DTF sizes must be 0.5\" minimum and fit within 22\" × 96\".",
    size_out_of_range_uvdtf: "UV DTF sizes must be 0.5\" minimum and fit within 20\" × 60\".",
    order_not_found: "No order found with that number and email.",
    invalid_credentials: "Wrong email or password.",
    too_many_attempts: "Too many attempts. Try again in 15 minutes.",
    wrong_password: "Current password is incorrect.",
    bad_gallery_type: "Use JPG, PNG, WEBP, MP4, MOV or WEBM.",
    payment_unavailable: "Payment is temporarily unavailable. Please try again in a moment.",
    paypal_declined: "PayPal couldn't complete the payment. Please try again or pay by card.",
  },
};

const fr = {
  brand: "MC Illusions Prints",
  nav: { order: "Commander", types: "DTF vs UV DTF", pricing: "Prix", work: "Réalisations", track: "Suivi", cart: "Panier", admin: "Admin" },
  hero: {
    eyebrow: "Transferts DTF et UV DTF personnalisés",
    title1: "Votre logo.",
    title2: "Sur tout ce",
    title3: "que vous vendez.",
    sub: "Téléversez votre PNG, choisissez DTF ou UV DTF, la taille, et voyez votre prix instantanément. Imprimé au Québec et livré directement chez vous dans un emballage neutre.",
    cta: "Commencer ma commande",
    cta2: "Voir les prix",
    b1: "Aucun minimum",
    b2: "Prix instantané en $ CA",
    b3: "Livraison partout au Canada",
  },
  types: {
    title: "Deux façons de mettre votre marque sur vos produits",
    sub: "Vous hésitez? Le tissu, c'est DTF. Tout ce qui est dur et lisse, c'est UV DTF.",
    dtf: "Transferts DTF",
    dtf_for: "Vêtements et tissus",
    dtf_desc: "À presser à chaud sur t-shirts, kangourous, casquettes, sacs et uniformes. Doux, extensible et résistant au lavage sur coton, polyester et mélanges.",
    dtf_l: ["T-shirts et kangourous", "Casquettes et sacs", "Uniformes de travail", "Jusqu'à 22 po × 96 po"],
    uv: "Décalques UV DTF",
    uv_for: "Surfaces dures",
    uv_desc: "À coller sur tasses, gourdes, verre, métal, portables et emballages. Aucune presse requise. Imperméable et résistant aux égratignures.",
    uv_l: ["Tasses et gourdes", "Verre et métal", "Portables et étuis", "Jusqu'à 20 po × 60 po"],
  },
  work: {
    title: "Tout frais sorti de la presse",
    sub: "De vraies impressions réalisées pour des petites entreprises.",
    empty: "Nos dernières réalisations sont sur Instagram.",
    follow: "Suivez @mcillusionsprints",
  },
  how: {
    title: "Comment ça marche",
    s1: "Téléversez votre logo",
    s1d: "Un PNG transparent à 300 ppp donne l'impression la plus nette.",
    s2: "Type et taille",
    s2d: "DTF ou UV DTF, n'importe quelle taille en pouces, n'importe quelle quantité.",
    s3: "Payez en sécurité",
    s3d: "Voyez le prix exact avant de payer par carte.",
    s4: "Recevez vos impressions",
    s4d: "Livrées dans un emballage neutre, prêtes à appliquer.",
  },
  pricing: {
    title: "Des prix simples et honnêtes",
    sub: "Tous les prix en $ CA. Plus vous commandez de DTF, moins chaque pouce carré coûte cher.",
    dtf_head: "DTF · surface DTF totale de la commande",
    rate_head: "Prix / po²",
    upto: "Jusqu'à {n} po²",
    over: "Plus de {n} po²",
    uv_head: "UV DTF",
    uv_rate: "{rate} / po²",
    uv_note: "Un seul tarif, peu importe la quantité.",
    setup: "Frais de préparation par design et taille",
    extras: "Options",
    rush: "Urgent (même jour)",
    rush_v: "× {n} coût d'impression",
    cut: "Découpe de chaque pièce",
    cut_v: "{fee} / pièce",
    check: "Vérification du fichier",
    check_v: "{fee} / fichier",
    ship: "Livraison",
    ship_v: "{flat} fixe · gratuite au-delà de {free}",
    example: "Exemple : 50 logos de 4 po × 4 po en DTF = 800 po² → {rate} / po².",
  },
  cta: { title: "Prêt à voir votre logo imprimé?", sub: "Obtenez un prix instantané en moins d'une minute.", btn: "Commencer ma commande" },
  builder: {
    title: "Créez votre commande",
    sub: "Téléversez un logo, choisissez la taille et la quantité, et voyez le prix en direct.",
    s1: "Type d'impression",
    s2: "Votre logo",
    rules: ["PNG seulement", "300 ppp", "Fond transparent", "À la taille réelle d'impression"],
    drop: "Déposez votre PNG ici ou cliquez pour parcourir",
    drop_sub: "PNG à fond transparent · max 50 Mo",
    uploading: "Téléversement et vérification…",
    replace: "Remplacer le fichier",
    px: "{w} × {h} px",
    dpi: "{dpi} ppp",
    dpi_unknown: "ppp non défini",
    sharp: "Impression nette jusqu'à {w} po × {h} po à 300 ppp",
    warn_soft: "Votre fichier est plus petit que cette taille à 300 ppp. L'impression pourrait être floue ou pixelisée.",
    s3: "Taille (pouces)",
    width: "Largeur",
    height: "Hauteur",
    presets: "Tailles rapides (côté le plus long)",
    lock: "Garder les proportions du logo",
    limits_dtf: "DTF : 0,5 po min · max 22 po × 96 po",
    limits_uvdtf: "UV DTF : 0,5 po min · max 20 po × 60 po",
    s4: "Quantité",
    pieces: "pièces",
    notes: "Notes (facultatif)",
    notes_ph: "Quelque chose à savoir? ex. couleurs, emplacement…",
    s5: "Options",
    rush: "Urgent (même jour)",
    rush_d: "Double le coût d'impression. Commandez avant midi (HE) pour une production le jour même.",
    cut: "Découpe de chaque pièce",
    cut_d: "{fee} par pièce, prêt à presser ou à décoller.",
    check: "Vérification du fichier",
    check_d: "{fee} par fichier. Un pro vérifie votre fichier avant l'impression.",
    summary: "Votre prix",
    area: "Surface par pièce",
    total_area: "Surface totale",
    rate: "Tarif",
    print: "Impression",
    extras: "Options",
    setup: "Préparation (par design)",
    line_total: "Total de la ligne",
    per_piece: "≈ {p} par pièce",
    add: "Ajouter au panier",
    added: "Ajouté au panier",
    need_file: "Téléversez votre logo pour continuer",
    tier_note: "Tarif DTF basé sur {area} po² au total dans votre panier.",
    rush_cutoff: "Après midi (HE), la production urgente commence le jour ouvrable suivant.",
  },
  cart: {
    title: "Votre panier",
    empty: "Votre panier est vide.",
    start: "Commencer ma commande",
    more: "Ajouter un autre design",
    checkout: "Passer à la caisse",
    subtotal: "Sous-total",
    shipping: "Livraison",
    free: "Gratuite",
    total: "Total",
    tax_note: "Les taxes (TPS/TVQ ou TVH) sont ajoutées au paiement.",
    free_left: "Ajoutez {amt} pour la livraison gratuite",
    free_got: "Livraison gratuite débloquée",
    remove: "Retirer",
    qty: "Qté",
    each: "ch.",
  },
  checkout: {
    title: "Paiement",
    contact: "Coordonnées",
    name: "Nom complet",
    business: "Nom de l'entreprise",
    email: "Courriel",
    phone: "Téléphone",
    ship_to: "Livrer à",
    line1: "Adresse",
    line2: "App., bureau, unité (facultatif)",
    city: "Ville",
    province: "Province",
    postal: "Code postal",
    country: "Canada",
    pay: "Payer en sécurité",
    pay_card: "Payer par carte",
    pay_paypal: "Payer avec PayPal",
    or: "ou",
    paypal_tax: "Avec PayPal, la TPS/TVQ/TVH de votre province est ajoutée sur la page PayPal.",
    redirecting: "Redirection vers le paiement sécurisé…",
    note: "Vous serez redirigé vers Stripe pour payer par carte. Livré dans un emballage neutre.",
    summary: "Résumé de la commande",
    required: "Veuillez remplir tous les champs obligatoires.",
    postal_bad: "Veuillez entrer un code postal canadien valide.",
    email_bad: "Veuillez entrer un courriel valide.",
  },
  success: {
    checking: "Confirmation de votre paiement…",
    title: "Merci! Votre commande est confirmée.",
    order_no: "Numéro de commande",
    keep: "Conservez ce numéro pour suivre votre commande, avec votre courriel sur la page de suivi.",
    track: "Suivre ma commande",
    home: "Retour à l'accueil",
    pending: "Confirmation en cours. Cette page se mettra à jour automatiquement.",
    failed: "Nous n'avons pas pu confirmer votre paiement. Si vous avez été débité, contactez-nous avec votre courriel.",
  },
  cancel: { title: "Paiement annulé", sub: "Aucun montant n'a été débité. Votre panier est conservé.", back: "Retour au panier" },
  track: {
    title: "Suivre votre commande",
    sub: "Entrez votre numéro de commande et le courriel utilisé au paiement.",
    order_no: "Numéro de commande",
    email: "Courriel",
    submit: "Trouver ma commande",
    placed: "Passée le {d}",
    tracking: "Numéro de suivi",
    items: "Articles",
    timeline: "Progression",
  },
  status: {
    awaiting_payment: "En attente de paiement",
    paid: "Commande reçue",
    sent_to_ton_atelier: "En file d'impression",
    in_production: "En production",
    shipped: "Expédiée",
    delivered: "Livrée",
    cancelled: "Annulée",
  },
  admin_status: {
    all: "Toutes",
    awaiting_payment: "En attente de paiement",
    paid: "Payée",
    sent_to_ton_atelier: "Envoyée à Ton Atelier",
    in_production: "En production",
    shipped: "Expédiée",
    delivered: "Livrée",
    cancelled: "Annulée",
  },
  common: { dtf: "DTF", uvdtf: "UV DTF", rush: "Urgent", cut: "Découpe", check: "Vérif. fichier", loading: "Chargement…", save: "Enregistrer", saved: "Enregistré" },
  footer: { tag: "Transferts DTF et UV DTF personnalisés pour petites entreprises.", made: "Imprimé au Québec, Canada.", rights: "Tous droits réservés." },
  admin: {
    login_title: "Connexion admin",
    email: "Courriel",
    password: "Mot de passe",
    sign_in: "Se connecter",
    logout: "Déconnexion",
    orders: "Commandes",
    settings: "Prix et livraison",
    gallery: "Galerie",
    view_site: "Voir le site",
    no_orders: "Aucune commande ici pour l'instant.",
    order: "Commande",
    date: "Date",
    customer: "Client",
    items: "Articles",
    total: "Total",
    profit: "Profit",
    status: "Statut",
    back: "Toutes les commandes",
    contact: "Client",
    ship_to: "Livrer à (expédition neutre)",
    copy: "Copier l'adresse",
    copied: "Copié",
    lines: "Lignes d'impression",
    download: "Télécharger le PNG",
    breakdown: "Répartition",
    ta_cost: "Coût Ton Atelier",
    your_profit: "Votre profit",
    subtotal: "Sous-total",
    shipping: "Livraison facturée",
    tax: "Taxes perçues",
    paid: "Payé par le client",
    manage: "Gérer la commande",
    tracking: "Numéro de suivi",
    notes: "Notes internes",
    update: "Enregistrer",
    updated: "Commande mise à jour",
    history: "Historique",
    customer_notes: "Notes du client",
    lang: "Langue",
    dtf_tiers: "Paliers DTF (surface DTF totale)",
    min_area: "Plus de (po²)",
    rate: "Tarif Ton Atelier / po²",
    add_tier: "Ajouter un palier",
    uv_rate: "Tarif UV DTF Ton Atelier / po²",
    markup: "Votre majoration (× coût d'impression Ton Atelier, 2 = double)",
    profit_line: "Frais de préparation par ligne design/taille (profit en plus)",
    rush_mult: "Multiplicateur urgent (coût ×)",
    cut_fee: "Découpe par pièce",
    file_fee: "Vérification par fichier",
    ship_flat: "Livraison fixe",
    free_over: "Livraison gratuite au-delà de",
    save_settings: "Enregistrer les prix",
    settings_saved: "Prix enregistrés",
    pw_title: "Changer le mot de passe",
    pw_current: "Mot de passe actuel",
    pw_new: "Nouveau mot de passe (min 8 caractères)",
    pw_save: "Mettre à jour",
    pw_saved: "Mot de passe mis à jour",
    gallery_sub: "Téléversez des photos ou courtes vidéos de vos réalisations. Elles apparaissent dans la section « Tout frais sorti de la presse » de l'accueil.",
    gallery_add: "Téléverser photo ou vidéo",
    gallery_caption: "Légende (facultatif)",
    gallery_empty: "Aucune photo pour l'instant. Ajoutez la première!",
    gallery_uploaded: "Ajouté à la galerie",
    delete: "Retirer",
    delete_confirm: "Retirer cet élément de la galerie?",
    email_confirmation: "Courriel de confirmation",
    email_shipped: "Courriel d'expédition",
  },
  errors: {
    generic: "Une erreur est survenue. Veuillez réessayer.",
    not_png: "Seuls les fichiers PNG sont acceptés.",
    no_transparency: "Votre PNG doit avoir un fond transparent.",
    too_large: "Fichier trop volumineux (max 50 Mo).",
    invalid_image: "Impossible de lire ce fichier. Téléversez un PNG valide.",
    missing_upload: "Un de vos logos est manquant. Veuillez l'ajouter de nouveau.",
    size_out_of_range_dtf: "Les tailles DTF doivent faire au moins 0,5 po et tenir dans 22 po × 96 po.",
    size_out_of_range_uvdtf: "Les tailles UV DTF doivent faire au moins 0,5 po et tenir dans 20 po × 60 po.",
    order_not_found: "Aucune commande trouvée avec ce numéro et ce courriel.",
    invalid_credentials: "Courriel ou mot de passe incorrect.",
    too_many_attempts: "Trop de tentatives. Réessayez dans 15 minutes.",
    wrong_password: "Le mot de passe actuel est incorrect.",
    bad_gallery_type: "Utilisez JPG, PNG, WEBP, MP4, MOV ou WEBM.",
    payment_unavailable: "Le paiement est temporairement indisponible. Réessayez dans un instant.",
    paypal_declined: "PayPal n'a pas pu compléter le paiement. Réessayez ou payez par carte.",
  },
};

export const DICTS = { en, fr };
